import { Box, Flex, Button, Alert, AlertIcon } from "@chakra-ui/react";
import { showErrorAxios } from "infra/helpers/alerta";
import { showConfirm, showSuccess } from "infra/helpers/alerta";
import useAtivarPagamentoOnlineTenant from "core/features/tenants/hooks/useAtivarPagamentoOnlineTenant";
import useTenantPagamentoOnline from "core/features/tenants/hooks/useTenantPagamentoOnline";
import { useLoading } from "ui/components/GlobalLoading";

export default function FeedbackPagamentoOnline({
  tenantId,
}: {
  tenantId?: string;
}) {
  const { isLoading: isLoadingPagamentoOnline, mutate: handlePagamentoOnline } =
    useAtivarPagamentoOnlineTenant(tenantId!);

  const { data: tenant, isFetching } = useTenantPagamentoOnline(tenantId!);

  useLoading(isLoadingPagamentoOnline);

  if (isFetching) {
    return null;
  }

  if (!tenant) {
    return null;
  }

  if (tenant.integradoPagamentoOnline) {
    return (
      <Alert status="success" my="8px">
        <Box flex={1}>
          <Flex>
            <Flex>
              <AlertIcon />
            </Flex>
            <Flex flex={1}>Integrado com pagamento online</Flex>
          </Flex>
        </Box>
      </Alert>
    );
  }

  return (
    <Alert status="warning" my="8px">
      <Box flex={1}>
        <Flex>
          <Flex>
            <AlertIcon />
          </Flex>
          <Flex flex={1}>
           Não possui pagamento online habilitado.
          </Flex>
          <Flex>
            <Button
              size="xs"
              colorScheme={"yellow"}
              variant={"outline"}
              onClick={() => {
                showConfirm().then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    handlePagamentoOnline({} as any, {
                      onError: (err) => {
                        showErrorAxios(err);
                      },
                      onSuccess: () => {
                        showSuccess().then(() => {
                          window.location.reload();
                        });
                      },
                    });
                  }
                });
              }}
            >
              Habilitar
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Alert>
  );
}
